import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import {
  HERO_UREA_TRACTOR,
  HERO_3_FARMERS,
  HERO_LONE_SOWER,
} from "./assets";

const slides = [
  {
    key: "s1",
    img: HERO_UREA_TRACTOR,
    tint: "tint-green",
    eyebrow: "Factory To Farmer Traceability",
    title: (
      <>
        Every Fertilizer Bag, from Factory <br />
        to Farmer can be <em>Tracked!!</em>
      </>
    ),
    desc:
      "Factory to Farmer Traceability — QR-based end-to-end Fertilizer bag tracking from the factory gate to the farmer's hands. Real-time dashboard, zero fraud tolerance.",
    focal: "center 50%",
  },
  {
    key: "s2",
    img: HERO_3_FARMERS,
    tint: "tint-teal",
    eyebrow: "District-Level Visibility",
    title: (
      <>
        Real-Time Tracking. <br />
        Till Fertilizer Bag reached in <em>Farmer's Hand.</em>
      </>
    ),
    desc:
      "Monitor Fertilizer bag distribution across country in real-time. Live status of every Fertilizer Bag to dealer and every farmer can be tracked.",
    focal: "center 45%",
  },
  {
    key: "s4",
    img: HERO_LONE_SOWER,
    tint: "tint-violet",
    eyebrow: "AI Powered Protection",
    title: (
      <>
        Deviation or discrepancy Detection. <br />
        <em>Automated</em> Alerts.
      </>
    ),
    desc:
      "Any Fertilizer Bag if diverted, not reaches to Farmer then it can be traced.",
    focal: "center 40%",
  },
];

export default function HeroSlider() {
  const [active, setActive] = useState(0);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  const goNext = () => setActive((i) => (i + 1) % slides.length);
  const goPrev = () => setActive((i) => (i - 1 + slides.length) % slides.length);

  useEffect(() => {
    timer.current = setInterval(() => {
      setActive((i) => (i + 1) % slides.length);
    }, 6000);
    return () => { if (timer.current) clearInterval(timer.current); };
  }, []);

  return (
    <section className="hero" data-testid="hero-slider">
      {slides.map((s, i) => (
        <div
          key={s.key}
          className={`slide ${s.tint} ${active === i ? "active" : ""}`}
          style={{
            backgroundImage: `url(${s.img})`,
            backgroundPosition: s.focal,
          }}
        >
          <div className="slide-overlay" />
          <div className="slide-bg-pattern" />
        </div>
      ))}

      <div className="hero-content">
        <span className="eyebrow" key={`e-${active}`}>
          <span className="dot" />
          {slides[active].eyebrow}
        </span>
        <h1 key={`t-${active}`}>{slides[active].title}</h1>
        <p className="lead" key={`d-${active}`}>{slides[active].desc}</p>
        <div className="hero-buttons">
          <Link to="/login" className="btn-primary" data-testid={`hero-cta-primary-${active}`}>
            Open Dashboard <i className="fa-solid fa-arrow-right"></i>
          </Link>
          <a href="#how" className="btn-ghost" data-testid={`hero-cta-secondary-${active}`}>
            See How It Works
          </a>
        </div>
      </div>

      <button className="slide-nav prev" onClick={goPrev} aria-label="Previous slide" data-testid="hero-prev">
        <i className="fa-solid fa-arrow-left"></i>
      </button>
      <button className="slide-nav next" onClick={goNext} aria-label="Next slide" data-testid="hero-next">
        <i className="fa-solid fa-arrow-right"></i>
      </button>

      <div className="slide-dots">
        {slides.map((s, i) => (
          <button
            key={s.key}
            className={active === i ? "active" : ""}
            onClick={() => setActive(i)}
            aria-label={`Slide ${i + 1}`}
            data-testid={`hero-dot-${i}`}
          />
        ))}
      </div>
    </section>
  );
}
